export default "__VITE_PUBLIC_ASSET__df897582__"